
import { milliesSpeech } from "./stories/millies-speech";
import { uponAHilltop } from "./stories/upon-a-hilltop";
import { cryptozoologist } from "./stories/cryptozoologist";
import { handprints } from "./stories/handprints";
import { wontbehome } from "./stories/wontbehome";
import { carapace } from "./stories/carapace";
import { houseOfBread } from "./stories/house-of-bread";
import { artizan188Story } from "./stories/artizan-188-story";

// Helper function to convert date strings to Date objects
const getDateFromString = (dateStr: string) => {
  const [month, year] = dateStr.split(' ');
  const months = {
    January: 0, February: 1, March: 2, April: 3, May: 4, June: 5,
    July: 6, August: 7, September: 8, October: 9, November: 10, December: 11
  };
  return new Date(parseInt(year), months[month as keyof typeof months]);
};

// Sort stories by date (newest first)
export const stories = [
  artizan188Story,
  milliesSpeech,
  carapace,
  wontbehome,
  uponAHilltop,
  cryptozoologist,
  handprints,
  houseOfBread
].sort((a, b) => {
  const dateA = getDateFromString(a.date);
  const dateB = getDateFromString(b.date);
  return dateB.getTime() - dateA.getTime();
});

// Get unique categories from stories
export const categories = Array.from(
  new Set(stories.map(story => story.category))
).sort();
